import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ModalService } from '../shared/modals/modal.service';
import { Appointment } from '../shared/models/appointment.model';
import { AppointmentService } from '../shared/services/appointment.service';
import { SessionService } from '../shared/services/session.service';
import { RedirectService } from '../shared/services/redirect.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { Url } from '../shared/models/url/url.model';
import { environment } from '../../environments/environment';

@Component({
    templateUrl: 'cancel-interview.component.html',
    standalone: false
})
export class CancelInterviewComponent implements OnInit {

    public appointment:Appointment;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private modalService: ModalService,
                private spinnerService: SpinnerService,
                private appointmentService: AppointmentService,
                private sessionService:SessionService,
                private redirectService:RedirectService) { }

    ngOnInit() {
        this.spinnerService.show();
        this.route.queryParams.subscribe(params => {
            this.sessionService.token = params['token'];
            this.sessionService.user.id = params['zone'];
            this.sessionService.location.id = params['locationID'];
            this.sessionService.appointment.id = params['appointmentID'];
            // this.sessionService.returnUrl = params['returnUrl'];

            let returnUrl = null;
            let tempReturnUrl = params['returnUrl'];
            if (tempReturnUrl) {
                let returnURLsObj: any = environment.returnUrls;
                if (returnURLsObj.hasOwnProperty(tempReturnUrl)) {
                    returnUrl = returnURLsObj[tempReturnUrl];
                }
            }

            this.sessionService.returnUrl = returnUrl;

            let appCode = params['appCode'];

            let canProceed:boolean =
                ((this.sessionService.token && this.sessionService.token.length > 0)
                && (this.sessionService.appointment.id && this.sessionService.location.id)) ? true : false;

            if (canProceed) {
                this.appointmentService.getAppointment(this.sessionService.location.id.toString(),
                                                        this.sessionService.appointment.id.toString(),
                                                        appCode)
                    .subscribe(
                        res => {
                            this.spinnerService.hide();
                            if (res !== null) {
                                this.appointment = res;
                            } else {
                                this.router.navigate(['/']);
                            }
                        },
                        error => {
                            this.spinnerService.hide();
                            this.modalService.warn('There was an error retrieving your appointment. Please try again later.')
                                .then(res => {
                                    if (this.sessionService.returnUrl) {
                                        let url:Url = this.redirectService.getReturnUrl(RedirectService.ABORTED);
                                        window.location.href = url.toString();
                                    } else {
                                        this.router.navigate(['/']);
                                    }
                                });
                        }
                    );

            } else {
                this.spinnerService.hide();
                this.router.navigate(['/']);
            }

        });
    }

    public goBack() {
        if (this.sessionService.returnUrl) {
            window.location.href = this.sessionService.returnUrl;
        } else {
            this.router.navigate(['/']);
        }
    }

    public submitCancellation() {
        this.spinnerService.show();
        this.appointmentService.deleteAppointment(this.appointment)
            .subscribe(
                res => {
                    this.spinnerService.hide();
                    if (res) {
                        if (this.sessionService.returnUrl) {
                            let url:Url = this.redirectService.getReturnUrl(RedirectService.CANCELLED);
                            window.location.href = url.toString();
                        } else {
                            this.router.navigate(['/']);
                        }
                    } else {
                        this.modalService.alert('ERROR_MESSAGES.SERVICE_ERROR');
                    }
                },
                error => {
                    this.spinnerService.hide();
                    this.modalService.warn('There was an error cancelling your appointment. Please try again later.').then(
                        res => {
                            if (this.sessionService.returnUrl) {
                                let url:Url = this.redirectService.getReturnUrl(RedirectService.ERROR);
                                window.location.href = url.toString();
                            } else {
                                this.router.navigate(['/']);
                            }
                        }
                    );
                }
            );
    }

}
